import React, { useState, useEffect } from 'react'

// Deps
import { connect } from 'react-redux';
import userServices from 'services/user'
import { redirect } from 'controllers/navigator'

// Partials
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'
import Link from 'views/shared/partials/link'

// Utils
import { openModal } from 'utils/modals';

// Static Assets
import Logo from 'assets/images/shared/logo-light.svg'

const mapStateToProps = (state, ownProps) => {
	return {
		userData: state.user.data,
	}
}

const Register = (props) => {
	const [submitting, setSubmitting] = useState(false);
	const [success, setSuccess] = useState(false);
	
	const submitForm = (formData) => {
		setSubmitting(true);

		userServices.registerCompany(formData).then((payload) => {
			if(payload === 'step-1') {
				openModal(
					'register-validation',
					{
						formData: formData,
						onSuccess: () => {
							setSuccess(true);
						}
					}
				);
			}
		}).catch((request) => {
		}).finally(() => {
			setSubmitting(false);
		})
	}

	useEffect(() => {
		if (props.userData !== false && props.userData !== null) {
			redirect('dashboard');
		}
	}, [props.userData]);

	return (
		<main className="page register">
			<InputForm className="section register-form" onSubmit={submitForm}>
				<div className="wrapper">
					<Link href="login">
						<Image className="form-logo" src={Logo} />
					</Link>
					<div className="portlet">
						{!success ?
							<React.Fragment>
								<div className="portlet-header">
									<h1 className="portlet-title">Firmanızı Kayıt Edin</h1>
								</div>
								<div className="portlet-section">
									<div className="grid-container">
										<div className="row">
											<div className="col x12">
												<FormInput
													disabled={submitting}
													type="email"
													label="E-Posta"
													placeholder="E-Posta girin"
													name="email"
													autoComplete="email"
													validation={{
														required: 'E-posta adresi girmelisiniz.',
														email: 'Geçerli bir e-posta girmelisiniz.',
													}} />
											</div>
										</div>
										<div className="row">
											<div className="col x12">
												<FormInput
													type="phone"
													disabled={submitting}
													mask="phone"
													label="Telefon"
													placeholder="Telefon girin"
													name="phone_number"
													autoComplete="tel"
													validation={{
														required: "Telefon girmelisiniz",
														phone: "Geçerli bir telefon numarası girmelisiniz",
													}} />
											</div>
										</div>
										<div className="row">
											<div className="col">
												<FormInput
													disabled={submitting}
													type="password"
													label="Şifre"
													placeholder="Şifre girin"
													name="password"
													autoComplete="new-password"
													validation={{
														required: 'Şifre girmelisiniz.',
													}} />
											</div>
										</div>
									</div>
								</div>
								<div className="portlet-section bottom align-right border-top portlet-controls">
									<Btn
										nude underline
										href="login"
										tag="link">
										Giriş Ekranına Dön
									</Btn>
									<Btn
										big
										loading={submitting}
										disabled={submitting}
										type="submit">
										Başvuruyu Tamamla
									</Btn>
								</div>
							</React.Fragment>
							:
							<React.Fragment>
								<div className="portlet-header">
									<h1 className="portlet-title">Başvurunuz tarafımıza ulaşmıştır.</h1>
								</div>
								<div className="portlet-section bottom form-success">
									<div className="success-text wysiwyg">	
										<p>
											Değerlendirme işleminden sonra tarafınıza bilgilendirme yapılacaktır. Aktivasyon ekibimiz en kısa zamanda sizinle iletişime geçecektir. Bu süreçte siz de aşağıdaki evrakları hazırlarsanız en hızlı şekilde aktivasyonunuzu yapmaktan memnuniyet duyarız.
										</p>
										<ol>
											<li>Vergi levhası</li>
											<li>İmza sirküsü</li>
											<li>Yetkili nüfus cüzdanı fotokopisi</li>
											<li>Firmanın resmi hesabından yapılan bir işlemin dekontu</li>
										</ol>

										<p>Ödedim.com ekibi.</p>

										<Btn
											tag="link"
											href="login">
											Giriş Ekranına Dön
										</Btn>
									</div>
									<i className="success-icon icon-check"></i>
								</div>
							</React.Fragment>
						}
					</div>
				</div>
			</InputForm>
		</main>
	)
}

export default connect(mapStateToProps)(Register);